import { IconButton } from "@mui/material";
import { theme } from "app/App";
import DeleteIcon from "@mui/icons-material/Delete";
import FormRow from "components/form/FormRow";
import SelectInput from "components/form/input/SelectInput";
import TextOutput from "components/form/TextOutput";
import TabContainer from "components/tabs/TabContainer";
import TabPanel from "components/tabs/TabPanel";
import FormContent from "components/form/FormContent";
import { NestedField } from "components/form/input/NestedField";
import BasicAccordion from "components/basic/BasicAccordion";

// TODO: (b_2089) 5º

export function GenericParamFields({ name, tabFields, bottomFields }) {
    return (
        <NestedField prefix={name}>
            {tabFields ? (
                <TabContainer>
                    <TabPanel label="Manual">
                        <FormContent sx={{ gap: 0 }}>
                            <NestedField prefix="manual">{tabFields}</NestedField>
                        </FormContent>
                    </TabPanel>

                    <TabPanel label="Mecanizado">
                        <FormContent sx={{ gap: 0 }}>
                            <NestedField prefix="mecanizado">{tabFields}</NestedField>
                        </FormContent>
                    </TabPanel>
                </TabContainer>
            ) : null}

            {bottomFields}
        </NestedField>
    );
}

export function ParamFormRow({ label, children }) {
    return (
        // TODO: mover cor para o tema.
        <FormRow sx={{ "&:nth-of-type(even)": { backgroundColor: theme.palette.grey[200] }, p: 2 }}>
            <TextOutput sx={{ width: { xs: "100%", sm: "30%" }, maxWidth: { xs: "100%", sm: 250 } }}>
                {label}
            </TextOutput>
            {children}
        </FormRow>
    );
}

export function CompareSymbolSelectInput(props) {
    return <SelectInput options={["", "=", ">=", "<=", ">", "<"]} {...props} />;
}

/**
 * Accordion que contém os parâmetros de um indicador, para ser usado na configuração.
 */
export function ParamFieldsContainer({ param, defaultExpanded = false, onDelete }) {
    function handleDelete(event) {
        if (onDelete) {
            onDelete(event);
        }

        // Previne que o accordion mova ao clicar no botão dentro do summary.
        event.stopPropagation();
    }

    return (
        <BasicAccordion
            title={param.label}
            titleActions={
                onDelete ? (
                    <IconButton onClick={handleDelete}>
                        <DeleteIcon sx={{ color: "white" }} />
                    </IconButton>
                ) : null
            }
            defaultExpanded={defaultExpanded}
        >
            {param.fields}
        </BasicAccordion>
    );
}
